import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/router-info`

    return {
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
    }
}